import { Component, EventEmitter, ViewEncapsulation, Input, Output } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

import { DatacenterCodeTranslationFilterType,
	DynamicDatacenterFilter, SuggestiveListWithIdFilter } from '../../../models/datacenter-filters';
import { pageTransitions } from '../../../animations/page-transitions';
import { DatacenterFilterApiService } from '../../../services/datacenter-filter-api.service';

import { SuggestiveItemCodeFilterComponent } from './suggestive-item-code-filter.component';

@Component({
	selector: 'copo-suggestive-list-id-filter',
	templateUrl: './suggestive-list-id-filter.component.html',
	styleUrl: './suggestive-list-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	providers: [DatacenterFilterApiService],
	imports: [NgIf, NgFor, MatIconModule, MatRippleModule, SuggestiveItemCodeFilterComponent]
})

export class SuggestiveListIdFilterComponent implements DynamicDatacenterFilter<SuggestiveListWithIdFilter> {
	@Input() filter?: SuggestiveListWithIdFilter;
	@Output() readonly removeFilter = new EventEmitter<void>();
	@Input() isDefaultFilter?: boolean;

	removeValue(item: DatacenterCodeTranslationFilterType) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(this.filter.getValues().findIndex(search => search.code === item.code), 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return {
				id: this.filter.filterId,
				values: this.filter.getValues()
					.filter(filterValue => !filterValue.translation)
			};
		}
		return undefined;
	}
}
